module.exports = __webpack_public_path__ + "static/media/bookcaseLanding.62735b80.png";